class cAdminCustomMetadata {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnAddDocumentField = $('#add-document-field-btn');
        var elBtnEditDocumentField = $('#edit-document-field-btn');
        var elDocumentFieldsTable = $('#documentfields-table');
        this.elDocumentFieldAddForm = $('#add-document-field-form');
        this.elDocumentFieldEditForm = $('#edit-document-field-form');
        elBtnAddDocumentField.click(function (e) { return self.submitAddDocumentFieldForm(this, e); });
        elBtnEditDocumentField.click(function (e) { return self.submitEditDocumentFieldForm(this, e); });
        elDocumentFieldsTable.click(function (e) { self.documentfieldsTableClickHandler(e); });
        $(elDocumentFieldsTable).dataTable({
            'paging': true,
            'ordering': true,
            'info': true,
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Document Fields per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
    submitAddDocumentFieldForm(btn, e) {
        if (!$(this.elDocumentFieldAddForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the document field");
        }
        $(btn).button('loading');
        $(this.elDocumentFieldAddForm).ajaxSubmit({
            url: URL_ADMIN + '/items/addcustommetadata',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
    submitEditDocumentFieldForm(btn, e) {
        if (!$(this.elDocumentFieldEditForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the document field");
        }
        $(btn).button('loading');
        $(this.elDocumentFieldEditForm).ajaxSubmit({
            url: URL_ADMIN + '/items/updatecustommetadata',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
    documentfieldsTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);
        if ($(target).hasClass('edit')) {
            this.onDocumentFieldEditClick(row);
        }
        else if ($(target).hasClass('del')) {
            this.onDocumentFieldDelClick(row);
        }
    }
    onDocumentFieldEditClick(row) {
        $('#edit-document-field-modal').find('#edit-id').val($(row).data('id'));
        $('#edit-document-field-modal').find('#edit-name').val($(row).data('name'));
        $('#edit-document-field-modal').modal('show');
    }
    onDocumentFieldDelClick(row) {
        var bookFieldId = row.getAttribute('rel');
        if (confirm('Are you sure you want to delete this custom document field?')) {
            this.deleteDocumentField(bookFieldId);
        }
    }
    deleteDocumentField(document_field_id) {
        $.ajax({
            url: URL_ADMIN + '/items/deletecustommetadata/',
            type: 'post',
            dataType: 'json',
            data: {
                document_field_id: document_field_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
}
